import React, { Fragment } from 'react';
import { getRefinedDeliveryFee } from '../../../app/Helper/DeliveryHelper';

function DeliveryFeeTemplate({
  deliveryFeeText,
  isFeeTextGreen,
  deliveryCondition,
}) {
  return (
    <div>
      {deliveryFeeText &&
        (isFeeTextGreen ? <strong>{deliveryFeeText}</strong> : deliveryFeeText)}
      {deliveryCondition && (
        <Fragment>
          <span className="text_bar" />
          {deliveryCondition}
        </Fragment>
      )}
    </div>
  );
}

/**
 * 배송비 컴포넌트
 */
function DeliveryFee() {
  const refinedData = getRefinedDeliveryFee(TMON.htStaticData.htDealInfo);

  if (!refinedData) {
    return null;
  }

  const { isFeeTextGreen, deliveryFeeText, deliveryCondition } = refinedData;

  return DeliveryFeeTemplate({
    isFeeTextGreen,
    deliveryFeeText,
    deliveryCondition,
  });
}

export default DeliveryFee;
